export default "__VITE_ASSET__hlG6qRkz__"